export const dbName = "gudhub";
// export const dbVersion = 7;

//todo dynamic version change chatgpt used, maybe isnt good to use static  version